<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
          md="6"
        >
          <div class="form-group">
            <label>Filter By Channel</label>
            <b-select
              v-model="filter.channel"
              :options="filterChannels"
              @change="onFilterChanged"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="form-group">
            <label>Filter By Disposition Type</label>
            <b-select
              v-model="filter.disposition_type"
              :options="filterDispositionTypes"
              @change="onFilterChanged"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
        >
          <b-form-checkbox
            id="status"
            v-model="filter.status"
            name="status"
            value="1"
            unchecked-value="0"
            switch
            @change="onFilterChanged"
          >
            <strong>Show Active Only?</strong>
          </b-form-checkbox>
          <br>
        </b-col>
        <b-col cols="12">
          <b-button
            type="button"
            variant="success"
            @click="onShowAddForm"
          >
            Add Disposition
          </b-button>
        </b-col>
      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{
            tableSettings.currentPage * tableSettings.perPage -
              tableSettings.perPage +
              (data.index + 1)
          }}
        </template>

        <template #cell(active)="data">
          {{ data.item.active == 1 ? "Yes" : "No" }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditForm(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-disposition-form"
      scrollable
      no-close-on-backdrop
      :title="modalTitle"
      @ok="onConfirmAction"
    >
      <ValidationObserver ref="form">
        <form
          role="form"
          novalidate
        >
          <ValidationProvider
            #default="{ errors }"
            name="channel"
            vid="channel"
            rules="required"
          >
            <b-form-group>
              <label for="channel">Channel</label>
              <b-form-select
                id="channel"
                v-model="disposition.channel"
                :options="list.channels"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Please Select Channel --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            #default="{ errors }"
            name="disposition type"
            vid="disposition_type"
            rules="required"
          >
            <div class="form-group">
              <label for="disposition_type">Disposition Type</label>
              <b-form-select
                id="disposition_type"
                v-model="disposition.disposition_type"
                :options="formList.disposition_types"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Please Select Disposition Type --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="disposition name"
            vid="disposition_name"
            rules="required|max:100"
          >
            <b-form-group>
              <label for="disposition_name">Disposition Name</label>
              <b-input
                id="disposition_name"
                v-model="disposition.disposition_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter disposition name"
                autocomplete="off"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="disposition.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
            >
              Is Active?
            </b-form-checkbox>
          </div>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? "Update Record" : "Save Record" }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AxiosError, SupervisorDispositionService, SharedListService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'SupervisorDispositions',

  middleware: ['auth', 'supervisor'],

  metaInfo () {
    return {
      title: 'Dispositions'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      filter: {
        channel: 'All',
        disposition_type: 'All',
        status: 0
      },
      formList: {
        disposition_types: []
      },
      list: {
        channels: [],
        disposition_types: []
      },
      disposition: {
        id: null,
        active: 0,
        channel: null,
        disposition_name: '',
        disposition_type: null
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          {
            key: 'created_at',
            formatter: this.dateTimeFormatter,
            sortable: true
          },
          { key: 'disposition_type.type_name', label: 'disposition type' },
          { key: 'disposition_name', sortable: true },
          { key: 'active', label: 'IS ACTIVE?' },
          {
            key: 'updated_at',
            formatter: this.dateTimeFormatter,
            sortable: true
          }
        ]
      }
    }
  },

  computed: {
    modalTitle () {
      return this.state.editing ? 'Edit Disposition' : 'Add Disposition'
    },

    filterChannels () {
      return [{ value: 'All', text: 'All' }].concat(this.list.channels)
    },

    filterDispositionTypes () {
      return [{ value: 'All', text: 'All' }].concat(this.list.disposition_types)
    }
  },

  watch: {

    'filter.channel' (channel) {
      this.getDispositionTypes(channel)
    },

    'disposition.channel' (channel) {
      this.getDispositionTypesForForm(channel, this.disposition.disposition_type)
    }

  },
  mounted () {
    core.index()
    this.getChannels()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await SupervisorDispositionService.get(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_text: ctx.filter,
            filter_channel: this.filter.channel,
            filter_disposition_type: this.filter.disposition_type,
            filter_status: this.filter.status
          })
        )
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async getDispositionTypesForForm (channel, dispositionType = null) {
      this.state.busy = true

      await SharedListService.getDispositionTypes(`channel_id=${channel}`).then(({ data }) => {
        this.formList.disposition_types = data.map(({ id, type_name }) => ({
          text: type_name,
          value: id
        }))

        const index = this.formList.disposition_types.findIndex(filter => filter.value === dispositionType)

        if (index >= 0) {
          this.disposition.disposition_type = dispositionType
        } else {
          this.disposition.disposition_type = null
        }

        this.state.busy = false
      })
    },

    async getDispositionTypes (channel) {
      this.state.busy = true
      await SharedListService.getDispositionTypes(`channel_id=${channel}`).then(({ data }) => {
        this.list.disposition_types = data.map(({ id, type_name }) => ({
          text: type_name,
          value: id
        }))

        this.filter.disposition_type = 'All'
        this.state.busy = false
      })
    },

    async getChannels () {
      this.state.busy = true
      await SharedListService.getChannels().then(({ data }) => {
        this.list.channels = data.map(({ id, channel_name }) => ({
          text: channel_name,
          value: id
        }))

        this.state.busy = false
      })
    },

    onShowAddForm () {
      this.state.editing = false
      this.disposition.id = null
      this.disposition.active = 1
      this.disposition.channel = null
      this.disposition.disposition_name = ''
      this.disposition.disposition_type = null
      this.$bvModal.show('modal-disposition-form')
    },

    onShowEditForm (item) {
      this.state.editing = true
      this.disposition.id = item.id
      this.disposition.active = item.active
      this.disposition.channel = item.disposition_type.channel_id
      this.disposition.disposition_name = item.disposition_name
      this.disposition.disposition_type = item.disposition_type.id

      this.getDispositionTypesForForm(item.disposition_type.channel_id, item.disposition_type.id)

      this.$bvModal.show('modal-disposition-form')
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          let title = 'Do you really want to create disposition?'

          if (this.state.editing) {
            title = 'Do you really want to save changes?'
          }

          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: title,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              if (!this.state.editing) {
                return this.onFormPostSubmit()
              } else {
                return this.onFormPutSubmit()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk(
            'Oppss! There were problem with your inputs.',
            {
              title: 'Validation Error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger'
            }
          )
        }
      })
    },

    onFilterChanged () {
      this.$refs.table.refresh()
    },

    async onFormPostSubmit () {
      return new Promise(resolve => {
        this.state.busy = true
        SupervisorDispositionService.post(this.disposition).then(response => {
          this.state.busy = false
          this.$bvModal.hide('modal-disposition-form')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: response.data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.table.refresh()
          })
        }).catch(error => {
          this.state.busy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    },

    async onFormPutSubmit () {
      return new Promise(resolve => {
        this.state.busy = true
        SupervisorDispositionService.put(this.disposition).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-disposition-form')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.table.localItems, { id: data.disposition.id })
            row.active = data.disposition.active
            row.disposition_name = data.disposition.disposition_name
            row.disposition_type = data.disposition.disposition_type
            row.disposition_type_id = data.disposition.disposition_type_id
            row.updated_at = data.disposition.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    }
  }
}
</script>
